var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.cd},[_c('div',{class:_vm.$style.wrap,style:({ 'animation-play-state': _vm.playing ? 'running' : 'paused' })},[_c('div',{class:_vm.$style.cdBody},[_c('div',{class:_vm.$style.hole})])])])}
var staticRenderFns = []

export { render, staticRenderFns }